import { Button, Modal } from '@ui';
import * as css from './UnselectCoachModal.css';
import { useTranslate } from '@i18n';

type UnselectCoachModalProps = {
    isOpen: boolean;
    onDismiss: () => void;
    onConfirm: () => void;
};

export const UnselectCoachModal = ({ isOpen, onDismiss, onConfirm }: UnselectCoachModalProps) => {
    const t = useTranslate();
    return (
        <Modal
            title={t('menu.user_settings_coach_unselect_title')}
            open={isOpen}
            variant="partial"
            footer={{
                primary: (
                    <div className={css.buttonGroup}>
                        <Button onClick={onDismiss} variant="secondary">
                            {t('generic_ui.cancel')}
                        </Button>
                        <Button onClick={onConfirm} variant="destroy">
                            {t('user_settings.unselect')}
                        </Button>
                    </div>
                ),
            }}
            onDismiss={onDismiss}
        >
            <p>{t('menu.user_settings_coach_unselect_message')}</p>
        </Modal>
    );
};
